// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2nWq5","footer":"ModalFilter_footer__3suv7"};